export const PO_TYPE_DESLOCACAO = "Deslocação";
export const PO_TYPE_PREVENCAO = "Prevenção";

const NO_HOURS_PO_TYPES = [PO_TYPE_DESLOCACAO, PO_TYPE_PREVENCAO];

export const isNoHoursPoType = (type?: string | null): boolean =>
    !!type && NO_HOURS_PO_TYPES.includes(type);
